import { render, staticRenderFns } from "./TamizajeClasificacionNino.vue?vue&type=template&id=3b6012b0&scoped=true"
import script from "./TamizajeClasificacionNino.vue?vue&type=script&lang=js"
export * from "./TamizajeClasificacionNino.vue?vue&type=script&lang=js"
import style0 from "./TamizajeClasificacionNino.vue?vue&type=style&index=0&id=3b6012b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6012b0",
  null
  
)

export default component.exports